import React, { useState, useEffect, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import AuthContext from "./AuthProvider";
import axiosInstance from "./axiosInstance";
import { Accordion, Button, Table } from "react-bootstrap";
import CheckpointInline from "./CheckpointInline";
import { Pencil, Trash } from 'react-bootstrap-icons';

import useWebSocket from "react-use-websocket";
import moment from 'moment'
import 'moment-duration-format';

import RaceEditModal from "./RaceEditModal";
import RunnerCSVRace from "./RunnerCSVRace";

import CheckpointAddModal from "./CheckpointAddModal";
import { Form } from "react-bootstrap";


const Race = () => {
    const [showModal, setShowModal] = useState(false);
    const closeModal = () => { setShowModal(false) }
    const openModal = () => { setShowModal(true) }

    const [race, setRace] = useState({});
    const { id } = useParams();
    const { user } = useContext(AuthContext);

    const [showAddCheckpointModal, setShowAddCheckpointModal] = useState(false);

    const openAddCheckpointModal = () => setShowAddCheckpointModal(true);
    const closeAddCheckpointModal = () => setShowAddCheckpointModal(false);

    const handleCheckpointAdded = (newCheckpoint) => {
        setRace(prevRace => ({
            ...prevRace,
            checkpoint_set: [...prevRace.checkpoint_set, newCheckpoint]
        }));
    };

    const { readyState, sendMessage, sendJsonMessage, lastMessage, lastJsonMessage } = useWebSocket(`${process.env.REACT_APP_WS_URL}/api/races/${id}/ws/`, {
        onOpen: () => {
            console.log('WebSocket opened');
        },
        onClose: () => {
            console.log('WebSocket closed');
        },

        shouldReconnect: () => true,
    });

    const [searchText, setSearchText] = useState("");
    const [sortedRacePersonTags, setSortedRacePersonTags] = useState([]);

    useEffect(() => {
        if (!race?.racepersontag_set) return;

        let data = [...race.racepersontag_set];

        // Filtre par recherche
        if (searchText) {
            const lower = searchText.toLowerCase();
            data = data.filter(item =>
                (item.runner?.name ?? "").toLowerCase().includes(lower) ||
                (item.runner?.firstname ?? "").toLowerCase().includes(lower) ||
                (item.bib ?? "").toLowerCase().includes(lower) ||
                (item.subrace ?? "").toLowerCase().includes(lower) ||
                (item.tag?.epc ?? "").toLowerCase().includes(lower)
            );
        }

        // // Tri par subrace (Infos) A-Z
        // data.sort((a, b) => {
        //     const subA = (a.subrace ?? "").toLowerCase();
        //     const subB = (b.subrace ?? "").toLowerCase();
        //     if (subA < subB) return -1;
        //     if (subA > subB) return 1;
        //     return 0;
        // });

        setSortedRacePersonTags(data);
    }, [race, searchText]);


    function sortRacePersonTagSet(race) {
        if (!race || !race.racepersontag_set) {
            return [];
        }

        const sortedRacePersonTagSet = race.racepersontag_set.sort((a, b) => {
            const lastCheckpointA = a.record_set[a.record_set.length - 1];
            const lastCheckpointB = b.record_set[b.record_set.length - 1];

            if (!lastCheckpointA && !lastCheckpointB) return 0;
            if (!lastCheckpointA) return 1;
            if (!lastCheckpointB) return -1;
            if (lastCheckpointA.checkpoint !== lastCheckpointB.checkpoint) {
                return lastCheckpointB.checkpoint - lastCheckpointA.checkpoint;
            }
            const timeA = new Date(lastCheckpointA.time);
            const timeB = new Date(lastCheckpointB.time);
            return timeA - timeB;
        });
        return sortedRacePersonTagSet;
    }

    useEffect(() => {
        axiosInstance.get(`/races/${id}/`)
            .then(response => {
                sortRacePersonTagSet(response.data);
                console.log(response.data);
                setRace(response.data);
            })
            .catch(error => {
                console.log(error);
            })
    }, [id]);

    useEffect(() => {
        if (lastJsonMessage) {
            if (lastJsonMessage.type === "reader.message") {
                const updatedRace = {
                    ...race,
                    checkpoint_set: race.checkpoint_set.map(checkpoint => {
                        if (checkpoint.reader && checkpoint.reader.id === lastJsonMessage.message.id) {
                            return {
                                ...checkpoint,
                                reader: lastJsonMessage.message
                            };
                        }
                        return checkpoint;
                    })
                };
                setRace(updatedRace);
            }
            else if (lastJsonMessage.type === "passing.message") {
                console.log(lastJsonMessage);
                const updatedRace = {
                    ...race,
                    racepersontag_set: race.racepersontag_set.map(racePersonTag => {
                        if (racePersonTag.id === lastJsonMessage.message.race_person_tag) {
                            // Mettez à jour le temps de passage dans la coursePersonTag correspondante
                            return {
                                ...racePersonTag,
                                record_set: [
                                    ...racePersonTag.record_set,
                                    lastJsonMessage.message
                                ]
                            };
                        }
                        return racePersonTag;
                    })
                };
                // sortRacePersonTagSet(updatedRace);
                setRace(updatedRace);
            }
            else {
                console.log(lastJsonMessage);
            }
        }
    }, [lastJsonMessage]);

    const setCheckpoints = (updatedCheckpoints) => {
        setRace({ ...race, checkpoint_set: updatedCheckpoints });
    };

    const handleStartRace = (e) => {
        axiosInstance.patch(`/races/${id}/`, { 'start': new Date() })
            .then(response => {
                setRace(response.data);
            })

    }

    const handleScanningToggle = (checkpointId, currentScanningState) => {
        const updatedRace = { ...race };
        const updatedCheckpoint = updatedRace.checkpoint_set.find(
            (checkpoint) => checkpoint.id === checkpointId
        );

        axiosInstance.patch(`/readers/${updatedCheckpoint.reader.id}/start/`, { start_inventory: !currentScanningState, mode: "running" })
            .then((response) => {
                updatedCheckpoint.reader = response.data;
                setRace(updatedRace);
            })
            .catch((error) => {
                console.log(error);
            })
    };

    const addPassage = (e, checkpointId, runnerId) => {
        e.preventDefault();
        axiosInstance.post('/records/', {
            checkpoint: checkpointId,
            race_person_tag: runnerId,
            time: moment().toISOString(),
            source: "manual"
        })
            .catch(error => {
                console.log(error);
            })
    }

    const deleteRecord = (e, id) => {
        e.preventDefault();
        axiosInstance.delete(`/records/${id}/`)
            .then(response => {
                setRace((prevRace) => {
                    const updatedRacePersonTagSet = prevRace.racepersontag_set.map((tag) => {
                        const updatedRecordSet = tag.record_set.filter(record => record.id !== id);
                        return { ...tag, record_set: updatedRecordSet };
                    });
                    return { ...prevRace, racepersontag_set: updatedRacePersonTagSet };
                });
            })
    }

    const renderAdmin = () => {
        if (user && user.is_super) {
            return (
                <>
                    <Button className="btn btn-primary mx-2" onClick={handleStartRace}>Start</Button>
                    <Button className="btn btn-primary mx-2" onClick={handleExport}>Export</Button>
                    <Button className="btn btn-primary mx-2" onClick={handleExportCSV}>Export CSV</Button>
                    <RunnerCSVRace raceId={race.id} />
                    <Link to="scan"><Button className="btn btn-primary mx-2">Scan</Button></Link>
                    <CheckpointInline
                        checkpoints={race.checkpoint_set}
                        setCheckpoints={setCheckpoints}
                        handleScanningToggle={handleScanningToggle}
                    />
                    <Button className="btn btn-primary mx-2" onClick={openAddCheckpointModal}>Add Checkpoint</Button>
                    <CheckpointAddModal
                        show={showAddCheckpointModal}
                        handleClose={closeAddCheckpointModal}
                        raceId={race.id}
                        onCheckpointAdded={handleCheckpointAdded}
                    />

                </>
            )
        }
    }

    const diffTime = (a, b) => {
        const timeA = moment(a)
        const timeB = moment(b)
        const duration = moment.duration(timeA.diff(timeB))
        return duration.format("hh:mm:ss", { trim: false })
    }

    const handleExport = () => {
        const filtered_json = {
            "name": race.name,
            'start': race.start,
            "result": race.racepersontag_set.map(item => ({
                "tag": item.tag.epc,
                "bib": item.bib,
                "name": item.runner ? item.runner.name : "",
                "firstname": item.runner ? item.runner.firstname : "",
                "time": item.record_set.map(record => ({
                    "timestamp": record.time,
                    "time": diffTime(moment(record.time), moment(race.start))
                }))
            }

            ))
        }


        const jsonString = JSON.stringify(filtered_json, null, 2); // null et 2 pour une indentation de 2 espaces
        const blob = new Blob([jsonString], { type: 'application/json' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${race.name}.json`);
        document.body.appendChild(link);
        link.click();

        // Nettoyer
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    const handleExportCSV = () => {
        const headerRow = [
            "Race Name", "EPC", "Dossard", "Nom", "Prénom",
            "Date de naissance", "Sexe", "Catégorie",
            "time", "timestamp", "start_time"
        ];

        const rows = race.racepersontag_set.flatMap(item => {
            const common = [
                race.name || "",
                item.tag?.epc ?? "",
                item.bib ?? "",
                item.runner?.name ?? "",
                item.runner?.firstname ?? "",
                item.runner?.birth ?? "",
                item.runner?.gender ?? "",
                (item.category ?? "") + (item.runner?.gender ?? "")
            ];

            // Si pas de records : on renvoie quand même une ligne "vide"
            if (!Array.isArray(item.record_set) || item.record_set.length === 0) {
                return [[...common, "", "", race.start ?? ""]];
            }

            // Une ligne par record
            return item.record_set.map(record => [
                ...common,
                // time calculé (peut être vide si diffTime indisponible)
                typeof diffTime === "function" ? diffTime(moment(record.time), moment(race.start)) : "",
                record.time ?? "",
                race.start ?? ""
            ]);
        });

        // Échappement CSV (gère les ; " et retours à la ligne)
        const escapeCell = (v) => {
            if (v === null || v === undefined) return "";
            const s = String(v);
            if (s.includes('"') || s.includes(';') || s.includes('\n') || s.includes('\r')) {
                return `"${s.replace(/"/g, '""')}"`;
            }
            return s;
        };

        const csvBody = [headerRow, ...rows]
            .map(row => row.map(escapeCell).join(";"))
            .join("\n");

        // Préfixe BOM correctement (au début du fichier)
        const csvString = '\uFEFF' + csvBody;


        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${race.name}.csv`);
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    return (
        <>
            <h1>{race.name}<Link onClick={openModal}><Pencil fontSize={20} /></Link></h1>
            <h5>{race.date}, {race.lieu}</h5>
            <h6>{race.start && moment(race.start).format("DD/MM/YY à HH:mm:ss")}</h6>
            {renderAdmin()}
            
            <Form.Control
                type="text"
                placeholder="Rechercher"
                value={searchText}
                onChange={e => setSearchText(e.target.value)}
            />

            <Table>
                <thead>
                    <tr>
                        <th>Place</th>
                        {
                            user?.is_super ? <th>EPC</th> : ""
                        }
                        <th>Nom</th>
                        {/* <th>Sexe</th> */}
                        <th>Dossard</th>
                        <th>Infos</th>
                        {/* {race.checkpoint_set && race.checkpoint_set.map((checkpoint) => (
                            <th key={checkpoint.id}>{checkpoint.name}</th>
                        ))} */}
                        <th>Tous les passages</th> {/* Nouvelle colonne */}
                        <th>Laps</th>
                        <th>Total</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedRacePersonTags && sortedRacePersonTags.map((item, index) => {
                        const passingTimes = {};
                        item.record_set.forEach((passing) => {
                            if (!passingTimes[passing.checkpoint]) {
                                passingTimes[passing.checkpoint] = [];
                            }
                            passingTimes[passing.checkpoint].push({ 'time': passing.time, 'id': passing.id });
                        });
                        return (
                            ((user?.is_super) || item.runner?.name) && (<tr key={index}>
                                <td>{index + 1}</td>
                                {user ? <td>{item.tag?.epc}</td> : ""}
                                <td>{item.runner ? item.runner.firstname : ""} {item.runner ? item.runner.name : ""}</td>
                                {/* <td>{item.runner ? item.runner.gender : ""}</td> */}
                                <td>{item.bib}</td>
                                {/* <td>{item.category}{item.runner?.gender}</td> */}
                                <td>{item.subrace}</td>
                                {/* {race.checkpoint_set && race.checkpoint_set.map((checkpoint) => (
                                    <td key={checkpoint.id}>
                                        <Accordion flush>
                                            <Accordion.Item eventKey={checkpoint.id}>
                                                {user?.is_super && (<Button onClick={(e) => addPassage(e, checkpoint.id, item.id)}>Passage</Button>)}
                                                <Accordion.Header>
                                                    {passingTimes[checkpoint.id] && (
                                                        race.start ? `${diffTime(moment(passingTimes[checkpoint.id][passingTimes[checkpoint.id].length - 1].time), race.start)} (${moment(passingTimes[checkpoint.id][passingTimes[checkpoint.id].length - 1].time).format('HH:mm:ss')})` : moment(passingTimes[checkpoint.id][passingTimes[checkpoint.id].length - 1].time).format('DD/MM/YYYY HH:mm:ss')
                                                    )}
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    {
                                                        passingTimes[checkpoint.id] && passingTimes[checkpoint.id].map((time, timeIndex) => (
                                                            <div key={timeIndex}>
                                                                {race.start ? `${diffTime(time.time, race.start)} (${moment(time.time).format("HH:mm:ss")})` : moment(time.time).format("d/m/YY HH:mm:ss")}
                                                                {user?.is_super ? (<Button onClick={e => deleteRecord(e, time.id)}>Delete</Button>) : ""}
                                                            </div>

                                                        ))
                                                    }
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </td>
                                ) 
                                )}*/}
                                <td>
                                    {item.record_set.map((time, timeIndex) => {
                                        const checkpointName = race.checkpoint_set.find(c => c.id === time.checkpoint)?.name ?? "Unknown";
                                        return (
                                            <div key={timeIndex} style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                <span>
                                                    {checkpointName} | {race.start ? diffTime(time.time, race.start) : moment(time.time).format("HH:mm:ss")}
                                                </span>
                                                {user?.is_super && (
                                                    <Button size="sm" variant="danger" onClick={e => deleteRecord(e, time.id)}><Trash /></Button>)}
                                            </div>
                                        )
                                    })}
                                </td>
                                <td>
                                    {item.laps?.map((lap, i) => (
                                        <div key={i}>
                                            {moment.duration(lap.time, "seconds").format("hh:mm:ss", { trim: false })}
                                        </div>
                                    ))}
                                </td>
                                <td>
                                    {(() => {
                                        const totalSeconds = item.laps?.reduce((acc, lap) => acc + lap.time, 0) || 0;
                                        return moment.duration(totalSeconds, "seconds").format("hh:mm:ss", { trim: false });
                                    })()}
                                </td>
                            </tr>))
                    }
                    )}
                </tbody>
            </Table>


            <RaceEditModal
                showModal={showModal}
                closeModal={closeModal}
                race={race}
                setRace={setRace}
            />
        </>
    )
}

export default Race;